import { BasePricebookItems } from '@/types/http/product/common';

export const computeDisplayPrice = (
  discountPrice?: number | null,
  sellPrice?: number | null,
  pricebook?: BasePricebookItems[]
) => {
  const basePrice = [discountPrice, sellPrice].filter((p): p is number => !!p && p > 0);
  const defaultPrice = basePrice.length ? Math.min(...basePrice) : 0;

  const unit1Prices = (pricebook ?? [])
    .filter((it) => it.min_unit === 1 && it.retail_price && it.retail_price > 0)
    .map((it) => it.retail_price as number);

  if (unit1Prices.length === 0) {
    return {
      displayPrice: defaultPrice,
      usingPricebookPrice: false,
    };
  }

  const pricebookMin = Math.min(...unit1Prices);

  const displayPrice = defaultPrice > 0 ? Math.min(defaultPrice, pricebookMin) : pricebookMin;

  return {
    displayPrice,
    usingPricebookPrice: displayPrice === pricebookMin && pricebookMin < defaultPrice,
  };
};
